<template>
  <section>
    <div class="user-main">
      <div class="utab clearfix">
        <ul class="clearlist clearfix fl">
          <li class="active">
            <a href="javascript:;">推荐商品</a>
          </li>
        </ul>
      </div>
      <div class="user-cont layui-card">
        <el-table
          :span-method="arraySpanMethod"
          border
          :data="contractGoods.data"
          style="width: 98%"
        >
          <el-table-column prop="title" label="商品名字"></el-table-column>
          <el-table-column prop="sn" label="商品编码"></el-table-column>
          <el-table-column label="商品信息" width="350" class-name="tablegoodsinfo">
            <template slot-scope="scope">
              <div class="hebin">
                <div class="clearfix cpinfo flex">
                  <div class="img">
                    <a :href="'/product/'+ scope.row.productid+'.html'" target="_blank">
                      <img :src="scope.row.indexpic" />
                    </a>
                  </div>
                  <div class="cont flex">
                    <div class style="width:240px">
                      <div class="name ellipsis-2">{{scope.row.title}}</div>
                      <div class="info">{{scope.row.specnames}}</div>
                    </div>
                    <div
                      class="color-primary"
                      style="width:50px;text-align:center"
                    >{{scope.row.unit}}</div>
                    <div
                      class="color-primary"
                      style="width:70px;text-align:center"
                    >{{scope.row.price}}</div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="60"></el-table-column>
          <el-table-column label="单价" width="80"></el-table-column>
          <el-table-column prop="amount3" label="操作">
            <template slot-scope="scope">
              <div class="addCar">
                <div class="numberbox">
                  <button
                    type="button"
                    class="btn jian"
                    :disabled="scope.row.num<=1"
                    @click="xiugaiNum(scope.row,'reduce')">
                    <span class="iconfont icon-jian"></span>
                  </button>
                  <input type="text" :min="1" v-model="scope.row.num" />
                  <button type="button" @click="xiugaiNum(scope.row,'add')" class="btn jia">
                    <span class="iconfont icon-jia"></span>
                  </button>
                </div>
                <el-button
                  type="primary"
                  round
                  size="small"
                  @click="addCart(scope.row)"
                >加入购物车{{scope.row.num}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="layui-card-body">
          <el-pagination
            class="fenye"
            background
            layout="prev, pager, next"
            :page-size="contractGoods.per_page"
            @current-change="currentPagegoods"
            :total="contractGoods.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import eventBus from "../../static/eventBus.js";
export default {
  name: "Askorder",
  data() {
    return {
      contractGoods: {},
      carnum: "",
      inputNum: 1
    };
  },
  watch: {
    carnum() {
      eventBus.$emit("changecarnum", this.carnum);
    }
  },
  props: {},
  methods: {
    currentPagegoods(e) {
      this.page = e;
      this.getOrderList();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return [1, 3];
      } else if (columnIndex === 3) {
        return [0, 0];
      } else if (columnIndex === 4) {
        return [0, 0];
      }
    },
    // 加入购物车
    async addCart(item) {
      console.log(item);
      let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.productid,
          num: item.num
        }
      });
      if (res) {
        this.carnum = res;
        this.$message.success("操作成功");
      }
    },
    xiugaiNum(item_i, type) {
      let contractGoods = this.contractGoods;
      contractGoods.data = contractGoods.data.map(item => {
        if (item.productid == item_i.productid) {
          if (type == "add") {
            item.num = Number(item.num) + 1;
            console.log("feswbfhedrfhyusvfuavu", item.num);
          } else {
            item.num = Number(item.num) - 1;
          }
        }
        return item;
      });
      this.contractGoods = contractGoods;
    },
    async getOrderList() {
      let contractGoods = await this.$fetch("shop/productrecommend");
      this.contractGoods = contractGoods;

      for (let i = 0; i < contractGoods.data.length; i++) {
        if (contractGoods.data[i].num) {
        } else {
          contractGoods.data[i]["num"] = 1;
        }
      }
      console.log("签约商品列表1111111111111111111", contractGoods);
    }
  },
  async mounted() {
    this.getOrderList();
  }
};
</script>

<style lang='scss' scoped>
.jishuqi {
  margin-bottom: 12px;
}
.cpgroup .bd .item .tit {
  margin-top: 0;
  font-size: 16px;
}
.cpgroup .bd .item .price {
  margin-top: 0;
}
.cpgroup .bd .item {
  padding-bottom: 0;
}
.img {
  margin-bottom: 10px;
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recommendGoods.vue